<template>
    <section v-if="!userIsEmpty('user')" class="profile-edit">
        <h1 class="heading">{{ $t("profileEdit.editingQuestionnaire") }}</h1>

        <!-- main -->
        <div class="info-block">
            <div class="form-block">
                <div class="form-group">
                    <label for="first_name" class="label">
                        {{ $t("feedback.name") }}:</label>
                    <input type="text" id="first_name" v-model="localUser.first_name" @input="updated($event)"
                        @change="updated($event)" name="first_name" v-validate="'required'" class="input"
                        :class="{ 'field-error': errors.has('first_name') }" />
                    <div v-if="errors.has('first_name')" class="v-error label-tip">
                        {{ errors.first("first_name") }}
                    </div>
                </div>
                <div class="form-group">
                    <label for="last_name" class="label">
                        {{ $t("profileEdit.lastName") }}:
                    </label>
                    <input type="text" id="last_name" v-model="localUser.last_name" @input="updated($event)"
                        @change="updated($event)" name="last_name" v-validate="'required'" class="input"
                        :class="{ 'field-error': errors.has('last_name') }" />
                    <div v-if="errors.has('last_name')" class="v-error label-tip">
                        {{ errors.first("last_name") }}
                    </div>
                </div>
                <div class="form-group multiselect-group">
                    <label for="gender" class="label">
                        {{ $t("profile.gender") }}
                        :</label>
                    <multiselect v-model="localUser.gender" :options="optionsConstructor('gender')" :searchable="false"
                        :placeholder="$t('profileEdit.chooseGender')" :custom-label="(opt) => costomGanderLabel(opt)"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        id="gender" name="gender" class="multiselect-gender multiselect-no-overflow"
                        :class="{ 'multiselect-error': errors.has('gender') }"></multiselect>
                </div>
                <div class="form-group multiselect-group birthday-group">
                    <label for="birthday" class="label">
                        {{ $t("profile.dateBirth") }}:</label>
                    <div class="birthday-wrapper">
                        <multiselect v-model="localBirthday[0]" :options="dayOptions" :searchable="false"
                            :placeholder="$t('profileEdit.day')" selectLabel="" deselectLabel="" :option-height="26"
                            :allowEmpty="false" openDirection="bottom" :maxHeight="150" ref="day" id="day" name="day"
                            v-validate="'required|isAdult'" class="multiselect-day"
                            :class="{ 'multiselect-error': errors.has('day') }"></multiselect>
                        <multiselect v-model="localBirthday[1]" :options="monthOptions"
                            :custom-label="(opt) => customMonthLabel(opt)" :searchable="false"
                            :placeholder="$t('profileEdit.month')" selectLabel="" deselectLabel="" :option-height="26"
                            :allowEmpty="false" openDirection="bottom" :maxHeight="150" ref="month" id="month" name="month"
                            v-validate="'required|isAdult'" class="multiselect-month"
                            :class="{ 'multiselect-error': errors.has('month') }"></multiselect>
                        <multiselect v-model="localBirthday[2]" :options="yearOptions" :searchable="false"
                            :placeholder="$t('profileEdit.year')" selectLabel="" deselectLabel="" :option-height="26"
                            :allowEmpty="false" openDirection="bottom" :maxHeight="150" ref="year" id="year" name="year"
                            v-validate="'required|isAdult'" class="multiselect-year"
                            :class="{ 'multiselect-error': errors.has('year') }"></multiselect>
                    </div>
                    <div v-if="errors.has('day') || errors.has('month') || errors.has('year')
                        " class="v-error label-tip">
                        {{ errors.first("day") }}
                    </div>
                </div>
                <div class="form-group multiselect-group">
                    <label class="label"></label>
                    <multiselect v-model="localUser.show_birthday" :options="optionsConstructor('show_birthday')"
                        :searchable="false" :placeholder="$t('profileEdit.showDateBirth')"
                        :custom-label="(opt) => customBirthdayLabel(opt)" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" id="show_birthday"
                        name="show_birthday" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('show_birthday') }"></multiselect>
                </div>
                <div class="form-group">
                    <label for="city" class="label">{{ $t("profile.city") }}:</label>
                    <input type="text" id="city" v-model="localUser.city" @input="updated($event)" @change="updated($event)"
                        :maxlength="150" name="city" class="input" />
                </div>
                <div class="form-group multiselect-group">
                    <label for="education" class="label">
                        {{ $t("profileEdit.education") }}
                        :</label>
                    <multiselect v-model="localUser.education" :options="optionsConstructor('education')"
                        :searchable="false" :placeholder="$t('profileEdit.education')"
                        :custom-label="(opt) => customEducationLabel(opt)" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" id="education" name="education"
                        class="multiselect-select" :class="{ 'multiselect-error': errors.has('education') }"></multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="height" class="label">
                        {{ $t("profileEdit.height") }}
                        :</label>
                    <multiselect v-model="localUser.height" :options="optionsConstructor('height')" :searchable="false"
                        :placeholder="$t('profileEdit.height')" :custom-label="(opt) => customHeightLabel(opt)"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        id="height" name="height" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('height') }"></multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="weight" class="label">
                        {{ $t("profileEdit.weight") }}
                        :</label>
                    <multiselect v-model="localUser.weight" :options="optionsConstructor('weight')" :searchable="false"
                        :placeholder="$t('profileEdit.weight')" :custom-label="(opt) => customWeightLabel(opt)"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        id="weight" name="weight" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('weight') }"></multiselect>
                </div>
                <div class="form-group multiselect-group">
                    <label for="body_type" class="label">
                        {{ $t("profile.bodyImage") }}
                        :</label>
                    <multiselect v-model="localUser.body_type" :options="optionsConstructor('body_type')"
                        :searchable="false" :placeholder="$t('profileEdit.body_type')"
                        :custom-label="(opt) => customBodytypeLabel(opt)" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" id="body_type" name="body_type"
                        class="multiselect-select" :class="{ 'multiselect-error': errors.has('body_type') }"></multiselect>
                </div>
                <div class="form-group multiselect-group">
                    <label for="family_status" class="label">
                        {{ $t("profile.maritalStatus") }}
                        :</label>
                    <multiselect v-model="localUser.family_status" :options="optionsConstructor('family_status')"
                        :searchable="false" :placeholder="$t('profileEdit.family_status')"
                        :custom-label="(opt) => customFamilyLabel(opt)" selectLabel="" deselectLabel="" :option-height="26"
                        :allowEmpty="false" openDirection="bottom" id="family_status" name="family_status"
                        class="multiselect-select" :class="{ 'multiselect-error': errors.has('family_status') }">
                    </multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="amount_of_children" class="label">
                        {{ $t("profileEdit.children") }}
                        :</label>
                    <multiselect v-model="localUser.amount_of_children" :options="optionsConstructor('amount_of_children')"
                        :searchable="false" :placeholder="$t('profileEdit.amount_of_children')"
                        :custom-label="(opt) => customChildrenLabel(opt)" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" id="amount_of_children"
                        name="amount_of_children" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('amount_of_children') }"></multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="acquaintance_goal" class="label">
                        {{ $t("profile.purposeDating") }}
                        :</label>
                    <multiselect v-model="localUser.acquaintance_goal" :options="optionsConstructor('acquaintance_goal')"
                        :searchable="false" :placeholder="$t('profileEdit.amount_of_children')"
                        :custom-label="(opt) => customAcquaintanceLabel(opt)" selectLabel="" deselectLabel=""
                        :option-height="26" :allowEmpty="false" openDirection="bottom" id="acquaintance_goal"
                        name="acquaintance_goal" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('acquaintance_goal') }"></multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="smoking" class="label">
                        {{ $t("profile.smoking") }}
                        :</label>
                    <multiselect v-model="localUser.smoking" :options="optionsConstructor('smoking')" :searchable="false"
                        :placeholder="$t('profileEdit.smoking')" :custom-label="(opt) => customSmokingLabel(opt)"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        id="smoking" name="smoking" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('smoking') }"></multiselect>
                </div>

                <div class="form-group multiselect-group">
                    <label for="alcohol" class="label">
                        {{ $t("profile.alcohol") }}
                        :</label>
                    <multiselect v-model="localUser.alcohol" :options="optionsConstructor('alcohol')" :searchable="false"
                        :placeholder="$t('profileEdit.alcohol')" :custom-label="(opt) => customAlcoholLabel(opt)"
                        selectLabel="" deselectLabel="" :option-height="26" :allowEmpty="false" openDirection="bottom"
                        id="alcohol" name="alcohol" class="multiselect-select"
                        :class="{ 'multiselect-error': errors.has('alcohol') }"></multiselect>
                </div>
                <!-- <div
          v-for="param in profileParams"
          :key="param.key"
          class="form-group multiselect-group"
        >
          <label :for="param.key" class="label">{{ param.label }}:</label>
          <multiselect
            v-model="localUser[param.key]"
            :options="optionsConstructor(param.key)"
            :searchable="false"
            :placeholder="param.label"
            :custom-label="(opt) => customLabel(opt, param.key)"
            selectLabel=""
            deselectLabel=""
            :option-height="26"
            :allowEmpty="false"
            openDirection="bottom"
            :id="param.key"
            :name="param.key"
            class="multiselect-select"
            :class="{ 'multiselect-error': errors.has(param.key) }"
          ></multiselect>
        </div> -->
                <div class="form-group multiselect-group languages-group">
                    <label for="languages" class="label">
                        {{ $t("profileEdit.knowledgeLanguages") }}:</label>
                    <multiselect v-model="localUser.languages" :options="languagesOptions" :multiple="true"
                        :searchable="true" placeholder="" :custom-label="(opt) => customLanguagesLabel(opt)" selectLabel=""
                        deselectLabel="" :option-height="26" :allowEmpty="true" :taggable="true" :hideSelected="true"
                        openDirection="bottom" id="languages" class="multiselect-select multiselect-multiple"></multiselect>
                </div>
                <div class="form-group textarea-group">
                    <label for="about" class="label">
                        {{ $t("profile.aboutMyself") }}:</label>
                    <textarea v-model="localUser.about" @input="updated($event)" @change="updated($event)" :maxlength="255"
                        id="about" class="textarea"></textarea>
                </div>
            </div>
        </div>

        <div class="buttons-row">
            <redirectButton pathname="profile" :params="{ id: user.id }" :html="$t('settings.cancel')"
                class="button-secondary"></redirectButton>
            <button @click="beforeSent" class="button" :class="{ 'button-loader': buttonLoader }">
                {{ $t("settings.save") }}
            </button>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">{{
            $t("auth.noAuthLink")
        }}</router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { consts } from "@/consts";
import { localizeValidation } from "@/mixins/localizeValidation";
import { updateForm } from "@/mixins/updateForm";
import { saveProfile } from "@/mixins/saveProfile";
// import {toggleTabs} from '@/mixins/toggleTabs';
import redirectButton from "@/components/Buttons/Redirect";
import Multiselect from "@/components/Blocks/Multiselect";
import { clickOutside } from "@/directives.js";

export default {
    name: "ProfileEdit",
    props: {
        i18n: Object,
    },
    components: {
        redirectButton,
        Multiselect,
    },
    mixins: [localizeValidation, updateForm, saveProfile],
    data() {
        return {
            tempUser: {},
            consts: consts,
            buttonLoader: false,
            dayOptions: [],
            monthOptions: [],
            yearOptions: [],
            languagesOptions: [],
            tempDay: "",
            tempMonth: "",
            tempYear: "",
            tempBirthday: [],
            search: null,
            selectedFriends: "",
            localFriends: [],
            isLoading: false,
            highlighted: null,
            profileParams: [
                { key: "education", label: "Образование" },
                { key: "height", label: "Рост" },
                { key: "weight", label: "Вес" },
                { key: "body_type", label: "Телосложение" },
                { key: "family_status", label: "Семейное положение" },
                { key: "amount_of_children", label: "Дети" },
                { key: "acquaintance_goal", label: "Цель знакомства" },
                { key: "smoking", label: "Курение" },
                { key: "alcohol", label: "Алкоголь" },
            ],
            gender: [
                { value: "1", text: this.$t('profileEdit.man') },
                { value: "2", text: this.$t('profileEdit.women') }
            ],
            months: [
                this.$t('profileEdit.january'),
                this.$t('profileEdit.february'),
                this.$t('profileEdit.march'),
                this.$t('profileEdit.april'),
                this.$t('profileEdit.may'),
                this.$t('profileEdit.june'),
                this.$t('profileEdit.july'),
                this.$t('profileEdit.august'),
                this.$t('profileEdit.september'),
                this.$t('profileEdit.october'),
                this.$t('profileEdit.november'),
                this.$t('profileEdit.december')
            ],
            showbirthday: [
                { value: "0", text: this.$t('profileEdit.showBirthday') },
                { value: "1", text: this.$t('profileEdit.dontShowBirthday') },
                { value: "2", text: this.$t('profileEdit.dontShowYear') }
            ],
            education: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.average') },
                { value: "2", text: this.$t('profileEdit.secondarySpecialised') },
                { value: "3", text: this.$t('profileEdit.incompleteHigherEducation') },
                { value: "4", text: this.$t('profileEdit.higherEducation') },
                { value: "5", text: this.$t('profileEdit.twoMoreUniversity') },
            ],
            height: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.low') },
                { value: "2", text: this.$t('profileEdit.belowAverage') },
                { value: "3", text: this.$t('profileEdit.medium') },
                { value: "4", text: this.$t('profileEdit.aboveAverage') },
                { value: "5", text: this.$t('profileEdit.high') },
            ],
            weight: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.weight40') },
                { value: "2", text: this.$t('profileEdit.weight4050') },
                { value: "3", text: this.$t('profileEdit.weight5060') },
                { value: "4", text: this.$t('profileEdit.weight6070') },
                { value: "5", text: this.$t('profileEdit.weight7080') },
                { value: "6", text: this.$t('profileEdit.weight8090') },
                { value: "7", text: this.$t('profileEdit.weight90100') },
                { value: "8", text: this.$t('profileEdit.weight100110') },
                { value: "9", text: this.$t('profileEdit.weight110120') },
                { value: "10", text: this.$t('profileEdit.weight120130') },
                { value: "11", text: this.$t('profileEdit.weight130140') },
                { value: "12", text: this.$t('profileEdit.weight140150') },
                { value: "13", text: this.$t('profileEdit.weight150') },
            ],
            body_type: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.skinny') },
                { value: "2", text: this.$t('profileEdit.ordinary') },
                { value: "3", text: this.$t('profileEdit.athletic') },
                { value: "4", text: this.$t('profileEdit.muscular') },
                { value: "5", text: this.$t('profileEdit.dense') },
                { value: "6", text: this.$t('profileEdit.complete') },
            ],
            family_status: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.singleUnmarried') },
                { value: "2", text: this.$t('profileEdit.dating') },
                { value: "3", text: this.$t('profileEdit.engaged') },
                { value: "4", text: this.$t('profileEdit.married') },
                { value: "5", text: this.$t('profileEdit.commonMarriage') },
                { value: "6", text: this.$t('profileEdit.inLove') },
                { value: "7", text: this.$t('profileEdit.itComplicated') },
            ],
            amount_of_children: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.childrenNot') },
                { value: "2", text: this.$t('profileEdit.childrenOne') },
                { value: "3", text: this.$t('profileEdit.childrenTwo') },
                { value: "4", text: this.$t('profileEdit.childrenThree') },
                { value: "5", text: this.$t('profileEdit.childrenMoreFour') },
            ],
            acquaintance_goal: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.friendship') },
                { value: "2", text: this.$t('profileEdit.correspondence') },
                { value: "3", text: this.$t('profileEdit.relationship') },
                { value: "4", text: this.$t('profileEdit.flirting') },
                { value: "5", text: this.$t('profileEdit.marriage') },
                { value: "6", text: this.$t('profileEdit.coOperativePlay') },
            ],
            smoking: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.smokingNot') },
                { value: "2", text: this.$t('profileEdit.smokingAlmost') },
                { value: "3", text: this.$t('profileEdit.smokingQuitting') },
                { value: "4", text: this.$t('profileEdit.smokingSmoke') },
            ],
            alcohol: [
                { value: "0", text: this.$t('profileEdit.notSelected') },
                { value: "1", text: this.$t('profileEdit.alcoholNot') },
                { value: "2", text: this.$t('profileEdit.alcoholLike') },
                { value: "3", text: this.$t('profileEdit.alcoholCompany') },
            ],
            languages: [
                this.$t('profileEdit.Abazin'),
                this.$t('profileEdit.Abenaki'),
                this.$t('profileEdit.Abkhaz'),
                this.$t('profileEdit.Avar'),
                this.$t('profileEdit.Avestan'),
                this.$t('profileEdit.Avango'),
                this.$t('profileEdit.Agul'),
                this.$t('profileEdit.Adyghe'),
                this.$t('profileEdit.Azerbaijani'),
                this.$t('profileEdit.Aymara'),
                this.$t('profileEdit.Ayni'),
                this.$t('profileEdit.Ainu'),
                this.$t('profileEdit.Akan'),
                this.$t('profileEdit.Akkadian'),
                this.$t('profileEdit.Alabama'),
                this.$t('profileEdit.Albanian'),
                this.$t('profileEdit.Aleut'),
                this.$t('profileEdit.Algerian'),
                this.$t('profileEdit.Altai'),
                this.$t('profileEdit.Amaliri'),
                this.$t('profileEdit.Amis'),
                this.$t('profileEdit.Amharic'),
                this.$t('profileEdit.English'),
                this.$t('profileEdit.AngloSaxon'),
                this.$t('profileEdit.Andi'),
                this.$t('profileEdit.Anuta'),
                this.$t('profileEdit.Apache'),
                this.$t('profileEdit.Arabela'),
                this.$t('profileEdit.Arabic'),
                this.$t('profileEdit.Aragonese'),
                this.$t('profileEdit.Aramaic'),
                this.$t('profileEdit.Aranese'),
                this.$t('profileEdit.Arantha'),
                this.$t('profileEdit.Arapaho'),
                this.$t('profileEdit.Argobba'),
                this.$t('profileEdit.Armenian'),
                this.$t('profileEdit.Arnaut'),
                this.$t('profileEdit.Aromanian'),
                this.$t('profileEdit.Archi'),
                this.$t('profileEdit.Assamese'),
                this.$t('profileEdit.Asturian'),
                this.$t('profileEdit.Atayal'),
                this.$t('profileEdit.Afar'),
                this.$t('profileEdit.Afrikaans'),
                this.$t('profileEdit.Ahom'),
                this.$t('profileEdit.Bagata'),
                this.$t('profileEdit.Bagvalal'),
                this.$t('profileEdit.Balinese'),
                this.$t('profileEdit.Bambara'),
                this.$t('profileEdit.Baniwa'),
                this.$t('profileEdit.Bantawa'),
                this.$t('profileEdit.Basque'),
                this.$t('profileEdit.Bassa'),
                this.$t('profileEdit.BahasaSinama'),
                this.$t('profileEdit.Bashkir'),
                this.$t('profileEdit.Bedja'),
                this.$t('profileEdit.Belarusian'),
                this.$t('profileEdit.Balochi'),
                this.$t('profileEdit.Bemba'),
                this.$t('profileEdit.Benkha'),
                this.$t('profileEdit.Bikol'),
                this.$t('profileEdit.Bislama'),
                this.$t('profileEdit.Blackfoot'),
                this.$t('profileEdit.Bulgarian'),
                this.$t('profileEdit.Bora'),
                this.$t('profileEdit.Bosnian'),
                this.$t('profileEdit.Breton'),
                this.$t('profileEdit.Budukh'),
                this.$t('profileEdit.Buruwai'),
                this.$t('profileEdit.Buryat'),
                this.$t('profileEdit.Bhutanese'),
                this.$t('profileEdit.Bugis'),
                this.$t('profileEdit.Bhojpuri'),
                this.$t('profileEdit.Vai'),
                this.$t('profileEdit.Wayampi'),
                this.$t('profileEdit.Welsh'),
                this.$t('profileEdit.Walloon'),
                this.$t('profileEdit.Warlpiri'),
                this.$t('profileEdit.Wakhi'),
                this.$t('profileEdit.Wend'),
                this.$t('profileEdit.Venetian'),
                this.$t('profileEdit.Veps'),
                this.$t('profileEdit.VikMungkan'),
                this.$t('profileEdit.Viraraturi'),
                this.$t('profileEdit.Votic'),
                this.$t('profileEdit.Volapuk'),
                this.$t('profileEdit.Võro'),
                this.$t('profileEdit.Vietnamese'),
                this.$t('profileEdit.Greek'),
                this.$t('profileEdit.Georgian'),
                this.$t('profileEdit.Waorani'),
                this.$t('profileEdit.Dari'),
                this.$t('profileEdit.Danish'),
                this.$t('profileEdit.Jersey'),
                this.$t('profileEdit.Dinka'),
                this.$t('profileEdit.Doluo'),
                this.$t('profileEdit.Duala'),
                this.$t('profileEdit.Dusun'),
                this.$t('profileEdit.EgyptianArabic'),
                this.$t('profileEdit.WestFrisian'),
                this.$t('profileEdit.Iban'),
                this.$t('profileEdit.Hebrew'),
                this.$t('profileEdit.Izhora'),
                this.$t('profileEdit.Ilokano'),
                this.$t('profileEdit.Ingush'),
                this.$t('profileEdit.Indonesian'),
                this.$t('profileEdit.Irish'),
                this.$t('profileEdit.Icelandic'),
                this.$t('profileEdit.Spanish'),
                this.$t('profileEdit.Italian'),
                this.$t('profileEdit.Kabardian'),
                this.$t('profileEdit.Kabyle'),
                this.$t('profileEdit.Kabuverdianu'),
                this.$t('profileEdit.Kaingang'),
                this.$t('profileEdit.Cayuga'),
                this.$t('profileEdit.Kalmyk'),
                this.$t('profileEdit.Kanuri'),
                this.$t('profileEdit.Kapampangan'),
                this.$t('profileEdit.Karaite'),
                this.$t('profileEdit.Karakalpak'),
                this.$t('profileEdit.Karamojong'),
                this.$t('profileEdit.KarachayBalkar'),
                this.$t('profileEdit.Karelian'),
                this.$t('profileEdit.Carian'),
                this.$t('profileEdit.Catalan'),
                this.$t('profileEdit.Kekchi'),
                this.$t('profileEdit.Celtiberian'),
                this.$t('profileEdit.Quechua'),
                this.$t('profileEdit.Chinese'),
                this.$t('profileEdit.Comanche'),
                this.$t('profileEdit.Coptic'),
                this.$t('profileEdit.Korean'),
                this.$t('profileEdit.Cornish'),
                this.$t('profileEdit.Cofán'),
                this.$t('profileEdit.Khmer'),
                this.$t('profileEdit.Ladin'),
                this.$t('profileEdit.Laz'),
                this.$t('profileEdit.Lezgian'),
                this.$t('profileEdit.Lebanese'),
                this.$t('profileEdit.Lithuanian'),
                this.$t('profileEdit.Macedonian'),
                this.$t('profileEdit.Maldivian'),
                this.$t('profileEdit.Mongolian'),
                this.$t('profileEdit.German'),
                this.$t('profileEdit.Dutch'),
                this.$t('profileEdit.Norwegian'),
                this.$t('profileEdit.Oromo'),
                this.$t('profileEdit.Persian'),
                this.$t('profileEdit.Polish'),
                this.$t('profileEdit.Portuguese'),
                this.$t('profileEdit.Romanian'),
                this.$t('profileEdit.Russian'),
                this.$t('profileEdit.Cebuano'),
                this.$t('profileEdit.Serbian'),
                this.$t('profileEdit.Sephardic'),
                this.$t('profileEdit.Syriac'),
                this.$t('profileEdit.Trukese'),
                this.$t('profileEdit.Turkish'),
                this.$t('profileEdit.Turkmen'),
                this.$t('profileEdit.WaAb'),
                this.$t('profileEdit.Udmurt'),
                this.$t('profileEdit.Uzbek'),
                this.$t('profileEdit.Ukrainian'),
                this.$t('profileEdit.UmeSami'),
                this.$t('profileEdit.Urdu'),
                this.$t('profileEdit.Finnish'),
                this.$t('profileEdit.French'),
                this.$t('profileEdit.Croatian'),
                this.$t('profileEdit.Zimbran'),
                this.$t('profileEdit.Chavacano'),
                this.$t('profileEdit.Chakma'),
                this.$t('profileEdit.Chamalins'),
                this.$t('profileEdit.Chamorro'),
                this.$t('profileEdit.Chamic'),
                this.$t('profileEdit.Chaha'),
                this.$t('profileEdit.Cheva'),
                this.$t('profileEdit.Chechen'),
                this.$t('profileEdit.Czech'),
                this.$t('profileEdit.Chickasaw'),
                this.$t('profileEdit.Chipewyan'),
                this.$t('profileEdit.Choctaw'),
                this.$t('profileEdit.Chuvash'),
                this.$t('profileEdit.Chukchi'),
                this.$t('profileEdit.Shoshone'),
                this.$t('profileEdit.Swedish'),
                this.$t('profileEdit.Alsatian'),
                this.$t('profileEdit.Estonian'),
                this.$t('profileEdit.Extremaduran'),
                this.$t('profileEdit.JamaicanPatois'),
                this.$t('profileEdit.Yao'),
                this.$t('profileEdit.Japanese'),
            ]
        };
    },
    computed: {
        ...mapGetters({
            userIsEmpty: "user/isEmpty",
            user: "user/fetchUser",
            userErrors: "user/errors",
            friends: "friends/fetchFriends",
            friendsIsEmpty: "friends/isEmpty",
        }),
        localUser: function () {
            if (Object.keys(this.tempUser).length) {
                return this.tempUser;
            }
            this.tempUser = Object.assign({}, this.user);
            return this.tempUser;
        },
        localBirthday() {
            if (this.tempBirthday.length) {
                return this.tempBirthday;
            }
            this.tempBirthday = this.user.birthday
                .split(".")
                .map((val) => parseInt(val));
            return this.tempBirthday;
        },
    },
    created() {
        this.localizeValidation();
        for (let k in this.consts.languages) {
            this.languagesOptions.push(parseInt(k) + 1);
        }
        for (let i = 1; i <= 31; i++) {
            this.dayOptions.push(i);
            if (i <= 12) {
                this.monthOptions.push(i);
            }
        }
        let today = new Date();
        for (let j = today.getFullYear(); j >= 1900; j--) {
            this.yearOptions.push(j);
        }

        let self = this;
        let isAdultMessage = this.$t('firstLogin.personsOverYears');

        const isAdultRule = {
            getMessage(field, data) {
                return (data && data.message) || isAdultMessage;
            },
            validate(value) {
                const getAge = (arr) => {
                    let bDate = new Date();
                    bDate.setDate(arr[0]);
                    bDate.setMonth(arr[1] - 1);
                    bDate.setFullYear(arr[2]);
                    bDate = bDate.getTime();
                    let years = new Date(+new Date() - bDate).getFullYear() - 1970;
                    return years >= 18;
                };
                let isValid = getAge(self.localBirthday);
                if (!isValid) {
                    self.$validator.errors.add({
                        field: "day",
                        msg: self.$t('firstLogin.personsOverYears'),
                    });
                    self.$validator.errors.add({
                        field: "month",
                        msg: "18+",
                    });
                    self.$validator.errors.add({
                        field: "year",
                        msg: "18+",
                    });
                } else {
                    self.$validator.errors.remove("day");
                    self.$validator.errors.remove("month");
                    self.$validator.errors.remove("year");
                }
                return { valid: isValid };
            },
        };

        this.$validator.extend("isAdult", isAdultRule);
    },
    methods: {
        optionsConstructor(key) {
            let arr;
            // if (key === "weight") {
            //   arr = [0];
            //   for (let i = 40; i < 160; i += 10) {
            //     arr.push(i);
            //   }
            //   return arr;
            // }
            arr = this.consts[key].map(function (e) {
                return e.value;
            });
            return arr;
        },
        customLabel(opt, label) {
            if (label == "weight") {
                if (opt == 0 || opt == "") {
                    return "Не выбрано";
                }
                return opt + " кг";
            }
            let text = "";
            let arr = this.consts[label].map(function (e) {
                if (e.value == opt) {
                    text = e.text;
                }
            });
            return text;
        },
        costomGanderLabel(opt) {
            return this.gender[opt - 1].text;
        },
        customMonthLabel(opt) {
            return this.months[opt - 1];
        },
        customBirthdayLabel(opt) {
            return this.showbirthday[opt].text;
        },
        customEducationLabel(opt) {
            return this.education[opt].text;
        },
        customHeightLabel(opt) {
            return this.height[opt].text;
        },
        customWeightLabel(opt) {
            return this.weight[opt].text;
        },
        customBodytypeLabel(opt) {
            return this.body_type[opt].text;
        },
        customFamilyLabel(opt) {
            return this.family_status[opt].text;
        },
        customChildrenLabel(opt) {
            return this.amount_of_children[opt].text;
        },
        customAcquaintanceLabel(opt) {
            return this.acquaintance_goal[opt].text;
        },
        customSmokingLabel(opt) {
            return this.smoking[opt].text;
        },
        customAlcoholLabel(opt) {
            return this.alcohol[opt].text;
        },
        customLanguagesLabel(opt) {
            //   return this.consts.languages[opt - 1];
            return this.languages[opt];
        },

        beforeSent() {
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.buttonLoader = true;
                    this.tempUser.birthday = this.localBirthday.join(".");
                    this.save(this.onSent, true, this.onSentError);
                } else {
                    this.$modal.show("dialog", {
                        title: this.$t('login.error'),
                        text: this.$t('profileEdit.oneFieldsFilled'),
                        buttons: [
                            {
                                title: this.$t('albumEdit.ok'),
                            },
                        ],
                    });
                }
            });
        },
        onSent() {
            this.buttonLoader = false;
            this.$modal.show("dialog", {
                title: this.$t('settings.success'),
                text: this.$t('profileEdit.changesRetained'),
                buttons: [
                    {
                        title: this.$t('albumEdit.ok'),
                    },
                ],
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
// @import '~@/assets/styles/components/_tabs';
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_profile-edit";
</style>
